import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityStocksRoutes: MenuInterface[] = [
    {
        code: 'StockQuantities',
        route: [
            {
                content: '$type/stocks/quantities',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'StockMovements',
        route: [
            {
                content: '$type/stocks/movements/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'InventoriesList',
        route: [
            {
                content: '$type/stocks/inventories/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'NewInventory',
        route: [
            {
                content: '$type/stocks/inventories/new',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionHistoriqueCessionStock_ViewModel',
        route: [
            {
                content: 'activity/stocks/stock-transfer/history/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionNouvelleCessionStock_ViewModel',
        route: [
            {
                content: 'activity/stocks/stock-transfer/new',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'GestionReceptionnerCessionStock_ViewModel',
        route: [
            {
                content: 'activity/stocks/stock-transfer/reception/list',
                focus: 'empty'
            }, 'content'
        ]
    }
];
